import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31d5974d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "admin-log-zone",
  style: {"padding":"15px"}
}
const _hoisted_2 = {
  key: 0,
  class: "admin-log-zone__empty"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "admin-log-card__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "admin-log-card__sep" }, " · ", -1))
const _hoisted_6 = { class: "admin-log-card__text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "admin-log-card__sep" }, " · ", -1))
const _hoisted_8 = {
  key: 1,
  class: "admin-log-card__text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "admin-log-card__sep" }, " · ", -1))
const _hoisted_10 = { class: "admin-log-card__text" }
const _hoisted_11 = {
  class: "cm-ui-dialog-title",
  style: {"top":"0"}
}

import { onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import dayjs from 'dayjs'
import Card from '@/views/dashboard/_components/card/card.vue'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import GroupPolicyDrawer from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.vue'
import {
  AdminOperationLogService,
  FetchOptions,
  isAdminLogDetailDisabled,
  LogItem,
  SECOND_MODEL_PATH,
} from '@/views/dashboard/notice-manage/admin-operation-log/admin-operation-log.service'
import { models as STATIC_ADMIN_MODEL_TREE } from '@/views/dashboard/notice-manage/admin-operation-log/model_names.js'
import type { AdminLogModelNode } from '@/views/dashboard/notice-manage/admin-operation-log/model_names'
import SwitchTerminalGroup from '@/views/dashboard/notice-manage/admin-operation-log/_components/switch-terminal-group/switch-terminal-group.vue'
import MessagePush from '@/views/dashboard/notice-manage/admin-operation-log/_components/message-push/message-push.vue'
import Approval from '@/views/dashboard/notice-manage/admin-operation-log/_components/Approval.vue'
import { useParseTime } from '@/hooks'
import { adminOperationDisplayText } from '@/utils/admin-operation-display'

const MESSAGE_FIRST_MODEL_ID = 3
const POLICY_SETTINGS_FIRST_MODEL_ID = 5
const SWITCH_TERMINAL_SECOND_MODEL_ID = 8

type AdminOperationRow = LogItem & {
  record_time?: number
  first_model?: number | string
  second_model?: number | string
  opt_data?: string | Record<string, unknown>
  template_id?: number
  variables?: string
}

const OVERVIEW_LOG_LIMIT = 5


export default /*#__PURE__*/_defineComponent({
  __name: 'log-information-zone',
  setup(__props) {

const { t, te, locale } = useI18n()

/** 列表接口实际字段多于 service 中 LogItem 声明 */
const router = useRouter()

const injector = useReflectiveInjector([AdminOperationLogService])
const adminOperationLogService = injector.get(AdminOperationLogService)

const loading = ref(false)
const list = ref<AdminOperationRow[]>([])

const dialogDetailVisible = ref(false)
const dialogDetailOptions = reactive<{
  record_id: number | null
  first_model_id: number | null
  second_model_id: number | null
  opt_data: Record<string, unknown>
}>({
  record_id: null,
  first_model_id: null,
  second_model_id: null,
  opt_data: {},
})

const groupPolicyDrawerData = reactive({
  visible: false,
  policyId: 0,
})

function buildIdLabelMaps (tree: AdminLogModelNode[]) {
  const firstModelIdMap: Record<string, string> = {}
  const secondModelIdMap: Record<string, string> = {}
  for (const m of tree) {
    firstModelIdMap[m.model_id] = m.labelKey
    firstModelIdMap[String(m.model_id)] = m.labelKey
    for (const s of m.models) {
      secondModelIdMap[s.model_id] = s.labelKey
      secondModelIdMap[String(s.model_id)] = s.labelKey
    }
  }
  return { firstModelIdMap, secondModelIdMap }
}

const { firstModelIdMap, secondModelIdMap } = buildIdLabelMaps(STATIC_ADMIN_MODEL_TREE)

/** 详情抽屉内子组件 props 需 string，opt_data 来自接口为弱类型 */
function detailOptStr (key: string) {
  const v = dialogDetailOptions.opt_data[key]
  return v == null ? '' : String(v)
}

function tModuleLabel (map: Record<string, string>, idRaw: string | number | null | undefined) {
  if (idRaw === null || idRaw === undefined || idRaw === '') return '--'
  const id = Number(idRaw)
  const key =
    map[idRaw as string] ??
    map[String(id)] ??
    (Number.isFinite(id) ? map[id] : undefined)
  if (!key) return t('noticeManage.adminModuleFallback', { id: idRaw })
  return t(key)
}

function fetchLogs () {
  const dateRange = [
    dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD'),
  ]
  const [startSec, endSec] = useParseTime(dateRange)
  const params: FetchOptions = {
    page: 1,
    limit: OVERVIEW_LOG_LIMIT,
    start_time: startSec,
    end_time: endSec,
  }
  loading.value = true
  adminOperationLogService
    .fetchAdminOperationLogData(params)
    .then(res => {
      list.value = (res.list || []) as AdminOperationRow[]
    })
    .finally(() => {
      loading.value = false
    })
}

/** 一级/二级模块：与管理员操作日志页一致，文案来自 model_names.js 的 labelKey + i18n；层级用「/」 */
function modulePathText (row: AdminOperationRow) {
  void locale.value
  const first = tModuleLabel(firstModelIdMap, row.first_model)
  const second = tModuleLabel(secondModelIdMap, row.second_model)
  const parts: string[] = []
  if (first !== '--') parts.push(first)
  if (second !== '--') parts.push(second)
  return parts.length ? parts.join(' / ') : '--'
}

function recordTimeText (row: AdminOperationRow) {
  void locale.value
  return row.record_time != null
    ? dayjs(Number(row.record_time) * 1000).format('YYYY-MM-DD HH:mm')
    : '--'
}

function formatAdminOperation (row: AdminOperationRow) {
  void locale.value
  return adminOperationDisplayText(t, te, row)
}

function logLineTitle (row: AdminOperationRow) {
  void locale.value
  return [row.admin_name || '--', recordTimeText(row), modulePathText(row), formatAdminOperation(row)].join(' · ')
}

function parseRowOptData (row: AdminOperationRow, secondModelId: number) {
  let optData: Record<string, unknown> | null = null
  const raw = row.opt_data
  if (raw == null || raw === '') return null
  try {
    if (typeof raw === 'string') {
      optData = JSON.parse(raw) as Record<string, unknown>
    } else if (typeof raw === 'object') {
      optData = { ...raw }
    }
    if (optData && secondModelId === 23) {
      optData.message = optData.file_name
    }
    if (optData && secondModelId === 22 && Array.isArray(optData.soft_name_list)) {
      optData.message = (optData.soft_name_list as string[]).join(',')
    }
  } catch {
    // 与列表页详情一致：解析失败则忽略
  }
  return optData
}

function showGroupPolicy (secondModelId: number, data: Record<string, unknown> | null) {
  groupPolicyDrawerData.visible = true
  groupPolicyDrawerData.policyId = (data?.id as number) || 0
}

function handlerModuleDetail (row: AdminOperationRow) {
  const recordId = Number(row.record_id)
  const firstModelId = Number(row.first_model)
  const secondModelId = Number(row.second_model)
  const optData = parseRowOptData(row, secondModelId)
  const path = SECOND_MODEL_PATH[secondModelId as keyof typeof SECOND_MODEL_PATH]
  if (path) {
    router.push(path)
    return
  }
  if (firstModelId === POLICY_SETTINGS_FIRST_MODEL_ID) {
    showGroupPolicy(secondModelId, optData)
    return
  }
  Object.assign(dialogDetailOptions, {
    record_id: recordId,
    first_model_id: firstModelId,
    second_model_id: secondModelId,
    opt_data: optData || {},
  })
  dialogDetailVisible.value = true
}

function handleViewMore () {
  router.push('/dashboard/admin-log')
}

onMounted(() => {
  fetchLogs()
})

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Card, {
      size: "third",
      title: _unref(t)('overviewZone.logTitle'),
      description: _unref(t)('overviewZone.logDesc'),
      "on-view-more": handleViewMore,
      "body-style": { padding: '0' }
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!loading.value && !list.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('common.noData')), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(list.value, (row, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.record_id || String(index),
                  class: "admin-log-card el-card"
                }, [
                  _createElementVNode("div", {
                    class: "admin-log-card__line",
                    title: logLineTitle(row)
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(row.admin_name || '--'), 1),
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, _toDisplayString(recordTimeText(row)), 1),
                    _hoisted_7,
                    (!_unref(isAdminLogDetailDisabled)(row))
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          class: "admin-log-card__module-link",
                          onClick: _withModifiers(($event: any) => (handlerModuleDetail(row)), ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(modulePathText(row)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(modulePathText(row)), 1)),
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(formatAdminOperation(row)), 1)
                  ], 8, _hoisted_3)
                ]))
              }), 128))
        ])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["title", "description"]),
    _createVNode(_component_el_drawer, {
      modelValue: dialogDetailVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogDetailVisible).value = $event)),
      "destroy-on-close": "",
      size: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(ContentAdaptLayout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('noticeManage.adminOperationLogDetailTitle', {
            first: tModuleLabel(_unref(firstModelIdMap), dialogDetailOptions.first_model_id),
            second: tModuleLabel(_unref(secondModelIdMap), dialogDetailOptions.second_model_id),
          })), 1),
            (dialogDetailOptions.second_model_id === SWITCH_TERMINAL_SECOND_MODEL_ID)
              ? (_openBlock(), _createBlock(SwitchTerminalGroup, {
                  key: 0,
                  id: dialogDetailOptions.record_id,
                  data: dialogDetailOptions.opt_data
                }, null, 8, ["id", "data"]))
              : _createCommentVNode("", true),
            (
          dialogDetailOptions.first_model_id === MESSAGE_FIRST_MODEL_ID ||
            [10, 11, 57, 59, 62, 61, 63, 64, 65, 66, 67].includes(
              dialogDetailOptions.second_model_id ?? -1,
            )
        )
              ? (_openBlock(), _createBlock(MessagePush, {
                  key: 1,
                  id: detailOptStr('task_id'),
                  message: detailOptStr('message')
                }, null, 8, ["id", "message"]))
              : _createCommentVNode("", true),
            (dialogDetailOptions.second_model_id === 50)
              ? (_openBlock(), _createBlock(Approval, {
                  key: 2,
                  id: detailOptStr('record_id')
                }, null, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(GroupPolicyDrawer, {
      modelValue: groupPolicyDrawerData.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((groupPolicyDrawerData.visible) = $event)),
      "policy-id": String(groupPolicyDrawerData.policyId || ''),
      "operate-type": "read"
    }, null, 8, ["modelValue", "policy-id"])
  ], 64))
}
}

})